export const colors = {
  bgPurpleLight: '#f6f7ff',
  subPurpleLight: '#c9ceff',
  mainPurple: '#6e75e8',
  subGradation: 'linear-gradient(119deg, #525de1 11.37%, #cac5ff 97.3%)',
  subPurplelight: '#b0b7ff',
  pointYellow: '#f6b552',
  mapRed: '#e16352',
  mapPurple: '#515bff',
  mapGradation: 'linear-gradient(119deg, #2d3dff 11.37%, #b8b0ff 97.3%)',
  white: '#ffffff',
  greyLight00: '#efefef',
  greyLight01: '#e5e5e5',
  greyLight02: '#cacaca',
  grey: '#b4b4b4',
  greyDark00: '#8a8a8a',
  greyDark01: '#636363',
  navy: '#0f112d',
  black: '#000000',
};
